import { useReportReviewerDashboardReviewJobs } from 'src/hooks/dashboard';
import { tryCall } from 'src/utils/core/functions';

export default () => {
  const {
    data: reportReviewerJobs,
    loading: reportReviewerJobsLoading,
    refetch: reFetchReportReviewerJobs
  } = tryCall(() => useReportReviewerDashboardReviewJobs(), { data: [], loading: false });

  const reFetchNextReportReviewerJobsBatch = (offset) => {
    reFetchReportReviewerJobs({ limit: 18, offset });
  };

  return {
    jobs:
      (reportReviewerJobs &&
        reportReviewerJobs.reportReviewerDashboardJobs) ||
      [],
    totalReportReviewerJobs: (reportReviewerJobs &&
        reportReviewerJobs.reportReviewerDashboardJobsPageInfo?.totalCount) ||
      0,
    reFetchNextReportReviewerJobsBatch,
    reportReviewerJobsLoading,
  };
};
